import type {Country} from '@/config/country/type';
import type {ApplicationCheckoutClasses} from '@/core/model/application-checkout';
import type {CheckoutLike} from '@/core/model/checkout';
import type {ComposerTranslation} from 'vue-i18n';

export function buildtooltip(trans: ComposerTranslation, country: Country, goodsPrice: CheckoutLike) {
    if (goodsPrice.application === null) {
        return '';
    }

    const tableHtml = "<table class='stf-body' style='text-align:left; margin: 3px;width: 130px; color: white'> ";

    const flatFeeHtml = `<tr>
                       <td>${trans('message.price.baseFee')} </td>
                       <td>${country.currency}${goodsPrice.application.flatFee}</td>
                    </tr>`;
    let classHtml = '';
    goodsPrice.application.classes.forEach((classItem: ApplicationCheckoutClasses) => {
        classHtml += `<tr>
                        <td>${trans('message.class')} ${classItem.classNumber} </td>
                        <td>${country.currency}${classItem.fee} </td>
                    </tr> `;
    });
    const totalFeeHtml = `<tr>
                        <td><b>${trans('message.price.total')}</b></td>
                        <td><b>${country.currency}${goodsPrice.application.total}</b></td>
                    </tr>`;
    return tableHtml + flatFeeHtml + classHtml + totalFeeHtml + '</table>';
}
